import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { searchHistoryBackend } from './search-history.backend';
import { searchHistoryReducer } from './search-history.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('searchHistory', searchHistoryReducer),
    BackendModule.forFeature('searchHistory', searchHistoryBackend),
  ],
})
export class DatastoreSearchHistoryModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-history/search-history.module.ts